module.exports = __webpack_public_path__ + "fonts/VetoSans-Bold.c5842036.ttf";